<template>
  <component
    v-bind:is="'li'"
    :class="{
      'active:bg-[#E8E8E8]': !props.disabled,
      'bg-white': true,
      'cursor-not-allowed': props.disabled,
      'cursor-pointer': !props.disabled,
      'flex-row': true,
      'font-bold': props.selected,
      'gap-sm': true,
      'hover:bg-[#F0F0F0]': !props.disabled,
      'items-center': true,
      'p-sm': true,
      'rounded-md': true,
      'select-none': true,
      'text-text-primary': !props.disabled,
      'text-text-disabled': props.disabled,
      flex: true,
      'z-20': true,
    }"
  >
    <slot></slot>
  </component>
</template>
<script setup lang="ts">
const props = defineProps<{
  selected?: boolean;
  disabled?: boolean;
}>();
</script>
